import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getPrivatePersons, getTreePersonsCount } from '../services/userService'
import useNotifications from './useNotifications'

/**
 * Hook for fetching a list of persons owned by a user (i.e. in their private space)
 * @param {string} cisId user CIS ID to fetch
 * @param {string} pageSize how many results to return
 * @param {string} index used to get the next page token
 * @param {string} nameFilter used to search by name
 * @returns {Object} list of owned persons and metadata
 */
const usePrivatePersons = (cisId, pageSize, index) => {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [privateSpacePersons, setPrivateSpacePersons] = useState()
  const [totalPersonsInSpace, setTotalPersonsInSpace] = useState()
  const [nameFilter, setNameFilter] = useState()

  useEffect(() => {
    getTreePersonsCount(cisId).then((response) => {
      setTotalPersonsInSpace(response.data)
    })
  }, [cisId])

  useEffect(() => {
    let isCurrent = true
    if (pageSize >= 20) {
      if (cisId !== null) {
        getPrivatePersons(cisId, null, pageSize, pageSize * index, nameFilter)
          .then((response) => {
            if (isCurrent) {
              setPrivateSpacePersons(response.data)
            }
          })
          .catch((err) => {
            if (isCurrent) {
              error(
                t('hooks.errors.gettingPrivatePersons', {
                  defaultValue: `Error getting private persons: ${err.message || ''}`,
                  message: err.message || '',
                }),
                err
              )
            }
          })
      }
    }
    return () => {
      isCurrent = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cisId, pageSize, index, nameFilter, error])

  return { ...privateSpacePersons, totalPersonsInSpace, nameFilter, setNameFilter }
}

export default usePrivatePersons
